import { Component, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { JournodexRegionsService } from '@Common/Journodex/services/journodex-regions.service';
import { IncludeExcludeKeys } from '@Common/Misc/models/include-exclude-model';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';

import { RecommendedRecipientService } from '@Discover/Targeting/components/Distribution/RecipientEditor/RecommendedRecipient/recommended-recipient-service';
import { TargetingSearch } from '@Discover/Targeting/models/targeting-search.model';
import { JournodexSubjectsService } from '@Common/Journodex/services/journodex-subjects.service';
import { JournodexEnumsService } from '@Discover/Core/services/journodex-enums.service';


@Component({
    selector: 'agpr-recommended-search-summary',
    templateUrl: './recommended-search-summary.component.html',
    styleUrls: ['./recommended-search-summary.component.scss'],
    standalone: false
})
export class RecommendedSearchSummaryComponent implements OnDestroy {

    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;

    searchModel: TargetingSearch;

    /** An object to cache all IncludeExclude properties on TargetingSearch as booleans for the template */
    searchIncludeExcludeNotEmpty: {[k in IncludeExcludeKeys<TargetingSearch>]: boolean };

    private subscriptions: Subscription[] = [];

    isQuickEditResponse: boolean = false;

    constructor(
        public recommendedRecipientService: RecommendedRecipientService,
        public journodexRegionsService: JournodexRegionsService,
        public journodexSubjectsService: JournodexSubjectsService,
        public journodexEnumsService: JournodexEnumsService,
    ) {

        this.subscriptions.push(
            this.recommendedRecipientService.getCachedSearch().subscribe((cachedSearch) => {
                this.searchModel = cachedSearch;
                this.setSearchIncludeExcludeNotEmpty();
                this.mapSearchIncludeExcludeNotEmpty();
            }),
            this.recommendedRecipientService.isQuickEditResponse().subscribe((isQuickEditResponse) => {
                this.isQuickEditResponse = isQuickEditResponse;
            }),
        );
    }

    /**
     * Sets the initial values of the map to false, and supplies the mapSearchIncludeExcludeNotEmpty()
     * method with the keys to use.
     */
    private setSearchIncludeExcludeNotEmpty() {
        this.searchIncludeExcludeNotEmpty = {
            subjects: false,
            monitoringKeywords: false,
            geographies: false,
            areasOfCoverage: false,
            mediaMarkets: false,
            jobRoles: false,
            outletIdsNames: false,
            outletSubjects: false,
            outletMonitoringKeywords: false,
            languages: false,
            jobTitles: false,
            contactIdsNames: false,
            mediaTypes: false,
            productTypes: false,
            marketSectors: false,
            coverageFocuses: false,
            productFrequencies: false,
            targetAudiences: false,
            list: false,
            distribution: false,
        };
    }

    /**
     * Maps/caches the isEmpty() method to each TargetingSearch IncludeExcludeModel object, for use in the template.
     */
    private mapSearchIncludeExcludeNotEmpty() {
        if (this.searchModel) {
            for (const k in this.searchIncludeExcludeNotEmpty) {
                if (this.searchModel.hasOwnProperty(k)) {
                    const key = k as keyof IncludeExcludeKeys<TargetingSearch> || '';
                    this.searchIncludeExcludeNotEmpty[key] = !this.searchModel[key].isEmpty();
                }
            }
        }
    }

    resetSearch() {
        this.recommendedRecipientService.resetSearch();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(
            subscription => subscription.unsubscribe()
        );
    }
}
